export enum UserRoles {
  ENGAGEMENT_ADMIN = 'Engagement Admin',
  ADMINISTRATOR = 'Administrator',
  CONTENT_AUTHORIZER = 'Content Authorizer',
  CONTENT_DEPLOYER = 'Content Deployer',
  DEVELOPER = 'Developer',
  PARTNER_POWER_USER = 'Partner Power User',
  EXTERNAL_PARTNER_POWER_USER = 'External Partner Power User',
}
